import { BaseTableRow, getHeaderName, TableProps, TableState } from "@/types";
import { GridActionsCellItem, GridRowParams } from "@mui/x-data-grid-pro";
import MoreVertIcon from "../../resources/images/icons-more-vertical.svg";
import { highlightKeyword } from "../../utilities";
import { Table } from "./Table";

interface CategoryTableRow extends BaseTableRow {
  name?: string | null;
}

interface CategoryTableProps extends Omit<TableProps<CategoryTableRow>, "onRowClick"> {
  onCategorySelect?: (e: any, row: CategoryTableRow) => void;
  onRowClick?: (params: GridRowParams<CategoryTableRow>, e: any) => void;
}

export class CategoryTable extends Table<CategoryTableRow, CategoryTableProps, TableState> {
  static columns = {
    name: {
      field: "name",
      label: "tableColumns.competencyCategory"
    },
    numberOfAttributeDefinitions: {
      field: "numberOfAttributeDefinitions",
      label: "tableColumns.competencies"
    },
    actions: {
      field: "actions",
      label: "tableColumns.actions"
    }
  };

  static defaultProps = {
    ...Table.defaultProps,
    columns: [
      { type: CategoryTable.columns.name },
      { type: CategoryTable.columns.numberOfAttributeDefinitions },
      { type: CategoryTable.columns.actions }
    ],
    noRowsMessage: "Click the New category button to add a category",
    rowHasAction: null
  };

  constructor(props: CategoryTableProps) {
    super(props);

    this.state = {
      ...this.state,
      sortModel: this.props.sortModel
        ? this.props.sortModel
        : [
            {
              field: "name",
              sort: "asc"
            }
          ]
    };
  }

  getRowId(c: CategoryTableRow) {
    return this.tableId + "_" + c.categoryId;
  }

  onRowClick(params: GridRowParams<CategoryTableRow>, e: any) {
    const { onCategorySelect } = this.props;
    if (onCategorySelect) onCategorySelect(e, params.row);
  }

  initColumns() {
    const { columns, sortable, keyword } = this.props;

    this.columns = [];

    if (!columns) return;

    columns.forEach((c) => {
      if (this.hasColumn(c)) {
        if (c.type === CategoryTable.columns.name)
          this.columns.push({
            field: "name",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            flex: 8,
            filterable: false,
            disableReorder: true,
            renderCell: (params) => highlightKeyword(params.row.name || "", keyword)
          });
      }
      if (this.hasColumn(c)) {
        if (c.type === CategoryTable.columns.numberOfAttributeDefinitions)
          this.columns.push({
            field: "numberOfAttributeDefinitions",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            width: 120,
            filterable: false,
            disableReorder: true,
            align: "center"
          });
      }
      if (c.type === CategoryTable.columns.actions)
        this.columns.push({
          field: "actions",
          type: "actions",
          filterable: false,
          disableReorder: true,
          align: "right",
          width: 40,
          getActions: (params) => [
            <GridActionsCellItem
              icon={<MoreVertIcon />}
              label='Actions'
              onClick={(e) => this.props.onCategoryAction?.(e, params.row)}
              key={Math.random().toString(36).substring(7)}
            />
          ]
        });
    });
  }
}
